module.exports = __webpack_public_path__ + "media/images/modules/bookings/m-bookingReserve__warning-4babf4a1fb1415ce793199a31a9dec21.svg";